<template>
  <div class="about">
    <h1>A Site for events to better the world</h1>
  </div>
</template>
